const iFrameResize = require('@iframe-resizer/parent');

import { listenForAttribution } from "../shared/attribution/embedCollector";

(function () {
  function postToIframe(contentWindow, command, data) {
    contentWindow.postMessage({
      from: "od_giving_embed.js",
      command: command,
      data: data
    }, "*");
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function postMessageReceived(event, iframe){
    var payload = event.data;

    if(typeof(payload) === "object" && payload.from === "PublicGivingCampaign.jsx"){
      var command = payload.command;
      var data = payload.data;

      switch (command) {
        case "opendateDonationCanceled":
          iframe.scrollIntoView();
          break;
        case "opendateDonationPlaced":
          iframe.scrollIntoView();
          break;
        case "ga.page_view":
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'page_view',
            page_location: data
          });
          break;
        case "ga.begin_checkout":
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
              items: data
            }
          });
          break;
        case "ga.purchase":
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'purchase',
            ecommerce: data
          });
          break;
        default:
          break;
      }
    }
  }

  if(typeof ODGivingEmbed !== 'function'){
    window.ODGivingEmbed = function(iframeID, options){
      var iframe = document.getElementById(iframeID);
      var contentWindow = iframe.contentWindow;

      var options = (options || {});
      var bgColor = options.bgColor;

      var clientId;
      if(typeof(ga) === "function"){
        ga(function(tracker){
          clientId = tracker.get('clientId');
        });
      }

      var customerioId = getCookie("_cioid");

      var wrappedPostMessageReceived = function(event){
        postMessageReceived(
          event,
          iframe
        );
      }

      if (window.addEventListener) {
        window.addEventListener("message", wrappedPostMessageReceived, false);
      } else {
        window.attachEvent("onmessage", wrappedPostMessageReceived);
      }

      listenForAttribution({
        iframe: iframe,
        surface: "embed",
        from: "od_giving_embed.js"
      });

      iframe.addEventListener("load", () => {
        if(bgColor && bgColor.length > 0){
          contentWindow.document.body.style.background = bgColor;
        }

        iFrameResize({license: "12ajjdewwwy-26rnhw2943-1s7g1u8ma0i"}, iframe);

        if(window.location && window.location.href){
          postToIframe(contentWindow, "setParentUrl", {
            parentUrl: window.location.href
          });
        }

        if(clientId && clientId.length > 0){
          postToIframe(contentWindow, "setClientID", {
            clientId: clientId
          });
        }

        if(customerioId && customerioId.length > 0){
          postToIframe(contentWindow, "setCustomerioId", {
            customerioId: customerioId
          });
        }

        postToIframe(contentWindow, "reportPageView", {});
      });
    };
  }
})();
